import { render, staticRenderFns } from "./masterDataTypeManagement.vue?vue&type=template&id=67044343&scoped=true"
import script from "./masterDataTypeManagement.vue?vue&type=script&lang=js"
export * from "./masterDataTypeManagement.vue?vue&type=script&lang=js"
import style0 from "./masterDataTypeManagement.vue?vue&type=style&index=0&id=67044343&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67044343",
  null
  
)

export default component.exports